<template>
  <div>
    <v-combobox
      class="combobox"
      v-model="value"
      :prepend-inner-icon="!value && 'fas fa-search fa-1x'"
      :items="items"
      browser-autocomplete="on"
      :placeholder="'Select ' + name"
      :item-text="mainProperty"
      :item-value="idProperty"
      :loading="loading"
      :search-input.sync="quickSearch"
      :required="required"
      :disabled="disabled"
      :rules="rules"
      :clearable="clearable"
      chips
      return-object>
      <template
        slot="selection"
        slot-scope="data">
        <v-chip>
          <EntityToAvatar
            :size="30"
            :schema="schema"
            :item="data.item" />
          {{ data.item[mainProperty] }}
        </v-chip>
      </template>

      <template
        slot="item"
        slot-scope="data">
        <v-list-tile-action>
          <EntityToAvatar
            :size="40"
            :schema="schema"
            :item="data.item" />
        </v-list-tile-action>

        <v-list-tile-content>
          <v-list-tile-title v-html="data.item[mainProperty]" />
        </v-list-tile-content>
      </template>
    </v-combobox>
  </div>
</template>

<script>
import { dataSourceMixin } from '../../../mixins/dataSourceMixin'
import EntityToAvatar from '../Entity/EntityToAvatar'

export default {
  mixins: [dataSourceMixin],
  components: {
    EntityToAvatar
  },
  props: {
    rules: {
      type: Array,
      required: false,
      default () {
        return []
      }
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    clearable: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  sync: ['value'],
  data () {
    return {
      serverSearch: null
    }
  },
  methods: {
    remove (item) {
      this.value = null
    }
  },
  watch: {
    serverSearch () {
      this.loading = true
      this.searchOnServer()
    },
    value (newValue, oldValue) {
      if (newValue && !newValue.id) {
        this.$nextTick(() => {
          this.value = oldValue
        })
      }
    }
  },
  mounted () {
    this.endpoint = 'list'
  }
}
</script>

<style lang="scss" scoped>
  .combobox {
    margin: 0;
    padding: 0;
  }
</style>
